import React, { useCallback, useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { PATH_JOB_CENTER } from '../../system/constants';
import { AppContext, LayoutContext } from '../../common/contexts';
import {
    DASHBOARD_MY_PROFILE,
    DASHBOARD_MY_CALENDAR,
    DASHBOARD_MY_JOBS,
    DASHBOARD_MY_SETTINGS,
    DASHBOARD_MY_MESSAGES,
    DASHBOARD_JOB_CENTER,
    BASE_URL,
    DASHBOARD_ID_MY_SETTINGS,
    DASHBOARD_ID_MY_PROFILE,
    DASHBOARD_ID_MY_JOBS,
    DASHBOARD_ID_MY_MESSAGES,
    DASHBOARD_ID_MY_CALENDAR,
} from '../../common/constants';
import { getMyCalendarCaption } from '../../common/calendarHelper';
import { setClassNameInDefns } from '../../common/definitionHelper';

import NavigationButton from './NavigationButton';
import PhotoSection from './PhotoSection';
import Footer from './Footer';

import _get from 'lodash/get';
import _reduce from 'lodash/reduce';
import _keys from 'lodash/keys';
import { Grid } from '@material-ui/core';

const styles = theme => ({
    root: {
        backgroundColor: '#FAFAFC',
        height: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('xl')]: { width: '256px', marginLeft: '64px' },
        [theme.breakpoints.down('lg')]: { marginTop: 16 },
    },
});

const getDefns = params => {
    const { props, profilePicUrl, dashboard, handleClickButton, dashboardData, currentThreadId, handleClickJobCenterButton } = params;
    const {
        classes,
        classes: { root: rootCls },
    } = props;

    const unreadMessagesCounts = _get(dashboardData, 'unreadMsgsCounts');
    const threadIdList = _keys(unreadMessagesCounts);
    const unreadMessagesCount = _reduce(threadIdList, (total, threadId) => (threadId !== currentThreadId ? total + _get(unreadMessagesCounts, threadId, 0) : total), 0);

    const myCalendarCaption = getMyCalendarCaption({ dashboardData });

    const defns = {
        root: {
            className: rootCls,
        },
        photoSection: {
            photoUrl: profilePicUrl, //profilePictureUrl,
        },
        myProfileButton: {
            label: DASHBOARD_MY_PROFILE,
            selected: dashboard === DASHBOARD_MY_PROFILE,
            onClick: handleClickButton.bind(null, DASHBOARD_ID_MY_PROFILE),
        },
        myCalendarButton: {
            label: DASHBOARD_MY_CALENDAR,
            selected: dashboard === DASHBOARD_MY_CALENDAR,
            onClick: handleClickButton.bind(null, DASHBOARD_ID_MY_CALENDAR),
            caption: myCalendarCaption,
        },
        myJobsButton: {
            label: DASHBOARD_MY_JOBS,
            selected: dashboard === DASHBOARD_MY_JOBS,
            onClick: handleClickButton.bind(null, DASHBOARD_ID_MY_JOBS),
        },
        mySettingsButton: {
            label: DASHBOARD_MY_SETTINGS,
            selected: dashboard === DASHBOARD_MY_SETTINGS,
            onClick: handleClickButton.bind(null, DASHBOARD_ID_MY_SETTINGS),
        },
        myMessagesButton: {
            label: DASHBOARD_MY_MESSAGES,
            selected: dashboard === DASHBOARD_MY_MESSAGES,
            onClick: handleClickButton.bind(null, DASHBOARD_ID_MY_MESSAGES),
            caption: unreadMessagesCount,
        },
        jobCenterButton: {
            label: DASHBOARD_JOB_CENTER,
            selected: dashboard === DASHBOARD_JOB_CENTER,
            onClick: handleClickJobCenterButton,
        },
        copyright: {
            variant: 'caption',
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const LeftNavigation = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const appContext = useContext(AppContext);
    const { currentUser } = appContext;
    const profilePicUrl = _get(currentUser, 'profilePicUrl');
    const context = useContext(LayoutContext);
    const { dashboard, setCurrentDashboard, dashboardData, currentThreadId } = context;
    const history = useHistory();

    const theme = useTheme();
    const lgMatches = useMediaQuery(theme.breakpoints.down('lg'));
    const mdMatches = useMediaQuery(theme.breakpoints.down('md'));

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback
    //---------------------------------------------------------------------
    const handleClickButton = useCallback(
        dashboardId => {
            setCurrentDashboard(dashboardId);
        },
        [setCurrentDashboard],
    );

    const handleClickJobCenterButton = useCallback(() => {
        history.push(`${BASE_URL}${PATH_JOB_CENTER}`);
    }, [history]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ props, profilePicUrl, dashboard, handleClickButton, dashboardData, currentThreadId, handleClickJobCenterButton });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div>
            {mdMatches ? null : (
                <div {...defns.root}>
                    <Grid container spacing={1} justify="center">
                        {lgMatches ? null : <PhotoSection {...defns.photoSection} />}

                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.myProfileButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.myCalendarButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.myJobsButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.myMessagesButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.jobCenterButton} />
                        </Grid>
                        <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
                            <NavigationButton {...defns.mySettingsButton} />
                        </Grid>
                    </Grid>
                    <span style={{ marginTop: '25px' }}>
                        <Footer />
                    </span>
                </div>
            )}
        </div>
    );
};

export default withStyles(styles)(LeftNavigation);
